import config from '~/config';

export interface Price {
	value: string;
	currency: string;
}

export const formatPrice = (price: Price, maximumFractionDigits = 2, locale: string[] = config.locale): string => {
	return Intl.NumberFormat(locale, {
		style: 'currency',
		currency: price.currency,
		maximumFractionDigits: maximumFractionDigits,
	})
		.format(Number(price.value))
		.replace(/([A-Z]) ?([0-9])/, '$1\xA0$2');
};
